import type { AerodromeRef } from '@/lib/db';
import { haversineNm } from '@/lib/parse';

import { NZ_AERODROMES } from './data';

/** Beyond this, a track's fix is more likely a private strip or paddock than the nearest listed aerodrome. */
export const AERODROME_MATCH_RADIUS_NM = 5;

export interface AerodromeMatch {
  aerodrome: AerodromeRef;
  distanceNm: number;
}

/** Nearest bundled aerodrome to a fix, or `undefined` if none is within `AERODROME_MATCH_RADIUS_NM`. */
export function nearestAerodrome(
  lat: number,
  lon: number,
  table: readonly AerodromeRef[] = NZ_AERODROMES,
): AerodromeMatch | undefined {
  let best: AerodromeMatch | undefined;
  for (const aerodrome of table) {
    if (aerodrome.lat === undefined || aerodrome.lon === undefined) {
      continue;
    }
    const distanceNm = haversineNm(lat, lon, aerodrome.lat, aerodrome.lon);
    if (best === undefined || distanceNm < best.distanceNm) {
      best = { aerodrome, distanceNm };
    }
  }
  return best !== undefined && best.distanceNm <= AERODROME_MATCH_RADIUS_NM ? best : undefined;
}
